import React, { useState } from "react";
import { Autocomplete, Box, TextField } from "@mui/material";
import {
  COUNTRY_CODE_OPTIONS,
  filterCountryCodeOptions,
  getCountryForCallingCode,
} from "./country-codes";

export { COUNTRY_CODE_OPTIONS };

// value / onChange use the ISO country ("IN"), not the calling code, since
// several countries share one (e.g. +1 for US and Canada).
const CountryCodeSelect = ({
  value,
  onChange,
  label = "Country Code",
  size,
  sx,
  disabled,
  required,
  TextFieldProps,
}) => (
  <Autocomplete
    options={COUNTRY_CODE_OPTIONS}
    value={COUNTRY_CODE_OPTIONS.find((option) => option.iso === value) || null}
    onChange={(_, option) => option && onChange(option.iso)}
    filterOptions={filterCountryCodeOptions}
    getOptionLabel={(option) => option?.label || ""}
    isOptionEqualToValue={(option, selected) => option.iso === selected.iso}
    disableClearable
    disabled={disabled}
    size={size}
    sx={sx}
    ListboxProps={{ sx: { maxHeight: 300 } }}
    renderOption={(props, option) => (
      <Box component="li" {...props} key={option.iso}>
        {option.label}
      </Box>
    )}
    renderInput={(params) => (
      <TextField {...params} label={label} required={required} {...TextFieldProps} />
    )}
  />
);

// For forms that store only the calling code ("91"). value may include "+";
// onChange gets the code without "+". Remembers the picked country so
// countries sharing a code (US/Canada) stay selected as picked.
export const CallingCodeSelect = ({ value, onChange, ...rest }) => {
  const [pickedIso, setPickedIso] = useState(null);
  const code = String(value || "").replace(/^\+/, "");
  const pickedOption = COUNTRY_CODE_OPTIONS.find((option) => option.iso === pickedIso);
  const iso = pickedOption?.callingCode === code ? pickedIso : getCountryForCallingCode(code);

  return (
    <CountryCodeSelect
      {...rest}
      value={iso}
      onChange={(nextIso) => {
        setPickedIso(nextIso);
        onChange(COUNTRY_CODE_OPTIONS.find((option) => option.iso === nextIso).callingCode);
      }}
    />
  );
};

export default CountryCodeSelect;
